export default "__VITE_ASSET__DHtrkat___"